export default function plate() {
  return {
    plateNo: "",
    class: "",
    issueYear: 0
  };
}
